import _ from 'lodash';
import { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { RootState } from 'src/actions/configuration/rootReducer';
import { DocumentResource } from 'src/actions/shared/createDocumentResource';
import { STATUS_UNSTARTED } from './useResource';

interface Options {
  fetch?: boolean;
  params?: any;
}

export default function useDocumentResource<T>(
  resource: DocumentResource<T>,
  options: Options = { fetch: true, params: null }
) {
  const dispatch = useDispatch();
  const paramHash = options.params ? JSON.stringify(options.params) : '';

  useEffect(
    () => {
      if (options.fetch) {
        dispatch(resource.effects.fetch(options.params));

        return () => {
          dispatch(resource.effects.unload(options.params));
        };
      }
    },
    // eslint-disable-next-line
    [dispatch, options.fetch, resource, paramHash]
  );
  return useResourceValue(resource);
}

export function useDocumentResourceAll<T>(resource: DocumentResource<T>) {
  const resourceValue = useResourceValue(resource);

  const dispatch = useDispatch();

  const { loadingState } = resourceValue;

  useEffect(() => {
    if (loadingState === STATUS_UNSTARTED) {
      dispatch(resource.effects.fetch({}));
    }
  }, [loadingState, dispatch, resource]);

  return resourceValue;
}

export function useResourceValue<T>(resource: DocumentResource<T>) {
  const state = useSelector((state: RootState) => state[resource.name]);
  return {
    ...state,
    value: useMemo(() => _.cloneDeep(state.value), [state.value]),
  };
}
